export const WAF_DYNAMIC_CONFIG_NAMES = {
  WAF_BROWSER_LATEST_VERSIONS: 'waf_browser_latest_versions',
} as const;
